





















































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { PageTitleConfig } from '@/shared/msw-app-title/type';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
const cssPrefix = 'msw-report-issues';
@Component({
  components: {
    MswAppTitle,
  },
})
export default class MswReportIssues extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  cssPrefix = cssPrefix;

  followLink(type: string) {
    switch (type) {
      case 'signature':
        this.$router.push('signIssues');
        break;
      case 'cfs':
        window.open(
          'https://capturelabs.sonicwall.com/m/feature/cfs',
          '_blank',
        );
        break;
      case 'security':
        window.open(
          'https://psirt.global.sonicwall.com',
          '_blank',
        );
        break;
      case 'botnet':
        window.open(
          'https://capturelabs.sonicwall.com/m/feature/ip-reputation-lookup',
          '_blank',
        );
        break;
    }
  }

  // For title of the page
  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('footer.reportIssues')
      .toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: this.loggedIn ? true : false,
      isShowSlash: this.loggedIn ? true : false,
      isShowParent: this.loggedIn ? true : false,
    };
  }
}
